import React from "react";
import "./TopActionButtons.scss";

export const TopActionButtons: React.FC = ({ children }) => (
  <div className="top-action-buttons">{children}</div>
);
